<template>
	<div class="p-4">
		<Steps :currentStep="1"></Steps>
	</div>
	<ProductsList></ProductsList>
</template>

<script>
import ProductsList from '../../Widgets/Contracts/RenewContract/ProductsList/ProductsList.vue';
import Steps from '../../Widgets/Contracts/RenewContract/Steps/Steps.vue';
export default {
	name: 'RenewContractStep1',
	components: {
		ProductsList,
		Steps,
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>